// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5224":"e279d5e3f333f09c","5760":"d9eb01d4a764a2a2","7509":"15537d14468466c3"}[chunkId] + ".js";
};